import React, { useEffect } from 'react';
import './rf.css';
import RMfoto from '../../Images/RFimage.jpg';
import Maquina1 from '../../Images/Maquina1.jpg';
import Maquina2 from '../../Images/Maquina2.jpg';

function RF() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

    return (
    <section>
      <section className='RF'> 
        <div className='RF-image'>
          <img src={RMfoto}></img>
        </div>
        <div className='RF-info'>
          <div className='RF-info-title'><h1>SERVICIOS RF</h1></div>
          <div className='RF-info-subtitle'><h2>Mantenimientos Preventivos y Correctivos en Máquinas Selladoras de Radio Frecuencia</h2></div>
          <div className='RF-info-info'><p>Contamos con el Servicio de Mantenimiento preventivo y correctivo en máquinas selladoras de Radiofrecuencia, tales como Hall Dieletric, Callanan, Cosmos-Kabar, entre otras, manejamos refacciones para estas mismas máquinas.</p></div>
        </div>
      </section>
      <section className='Maquinas'>
        <div className='Maquinas-title'><h1>MÁQUINAS SELLADORAS DE RADIOFRECUENCIA</h1></div>
        <div className='Maquinas-subtitle'><h2>Contáctanos para más información</h2></div>
        <div className='Maquinas'>
          <div className='Maquinas1y2'>
            <div className='Maquina1'>
              <div className='Maquina1-img'><img src={Maquina1}></img></div>
              <div className='Maquina1-title'><h2>Versión compacta</h2></div>
              <div className='Maquina1-info'><p>27 "Garganta Profunda</p></div>
            </div>
            <div className='Maquina2'>
              <div className='Maquina2-img'><img src={Maquina2}></img></div>
              <div className='Maquina2-title'><h2>El modelo más vendido</h2></div>
              <div className='Maquina2-info'><p>Sellador de barra blindado de garganta profunda de 40 ″ con alimentación coaxial y circuito desintonizado automático</p></div>
          </div>
          </div>
        </div>
      </section>
    </section>
    );
  }
  
export default RF;
  